import { IconButton, Stack, TooltipHost } from '@fluentui/react';
import React, { useState } from 'react';
import { CloneTripDialog } from './CloneTripDialog';
import { SectionProps } from '../../..';
import { Trip_trip } from '../../../__generated__/Trip';

interface CloneTripProps {
  tripItemsState: Map<string, SectionProps>;
  tripData: Trip_trip | null | undefined;
  setClonedTripId: React.Dispatch<React.SetStateAction<string | undefined>>;
}

export const CloneTrip: React.FC<CloneTripProps> = (props) => {
  const [showDialog, setShowDialog] = useState<boolean>(false);

  return (
    <Stack>
      <TooltipHost content="Clone">
        <IconButton
          iconProps={{ iconName: 'Copy' }}
          ariaLabel="Copy"
          onClick={() => setShowDialog(true)}
        />
      </TooltipHost>
      {showDialog && (
        <CloneTripDialog {...props} setShowDialog={setShowDialog} />
      )}
    </Stack>
  );
};
